import { useMutation } from '@tanstack/react-query'
import { useAccessToken } from '@/features/auth/state/auth'
import api from '@/lib/api'
import { exportClientsTenantReport } from '../utils/exportClientsTenantReport'

type ExportClientsTenantReportParams = {
  id_tenant: string
  tenantDisplayName?: string
  status?: string
  search?: string
}

export function useExportClientsTenantReport() {
  const token = useAccessToken()

  return useMutation({
    mutationFn: async ({ id_tenant, tenantDisplayName, status, search }: ExportClientsTenantReportParams) => {
      if (!token) throw new Error('Token de autenticação ausente')
      if (!id_tenant) throw new Error('Tenant inválido para exportação')

      const response = await api.get(`/clients/tenant/${id_tenant}/report`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          ...(status ? { status } : {}),
          ...(search?.trim() ? { search: search.trim() } : {})
        }
      })

      const data = response.data?.data
      if (!data) {
        throw new Error('Estrutura de resposta inesperada ao exportar relatório')
      }

      await exportClientsTenantReport({ ...data, tenantDisplayName })
      return data
    }
  })
}
